import { useTranslation } from "react-i18next";
import { RoutingType, RoutingTypeEnum } from "types/RoutingType";

import ButtonGroup, { TabOption } from "./ButtonGroup";

const RoutingTabPanel: React.FC<{
  selected?: RoutingType;
  onSelect: (routing: RoutingType) => void;
  hasError?: boolean;
  routingType?: "ALL" | "PORTS_AND_DOORS";
  className?: string;
}> = ({ selected, onSelect, hasError, routingType = "ALL", className }) => {
  const { t } = useTranslation("quoteRequest");

  const routingOptions: TabOption<RoutingType>[] =
    routingType === "ALL"
      ? [
          { value: RoutingTypeEnum.P2D, label: t("RoutingStep.routingTypes.P2D") },
          { value: RoutingTypeEnum.D2P, label: t("RoutingStep.routingTypes.D2P") },
          { value: RoutingTypeEnum.D2D, label: t("RoutingStep.routingTypes.D2D") },
          { value: RoutingTypeEnum.P2P, label: t("RoutingStep.routingTypes.P2P") },
        ]
      : [
          { value: RoutingTypeEnum.P2D, label: t("RoutingStep.routingTypes.P2D") },
          { value: RoutingTypeEnum.D2P, label: t("RoutingStep.routingTypes.D2P") },
        ];

  return (
    <ButtonGroup
      options={routingOptions}
      selected={selected}
      onSelect={onSelect}
      hasError={hasError}
      className={className}
    />
  );
};

export default RoutingTabPanel;
